import { useQuery } from '@tanstack/react-query';

import { listAffiliations } from '~/services/AgentHub/AgentService';

import { ListAffiliationsParams } from '~/types/services/agentHub';

export const affiliationsQueryKeys = {
  all: ['affiliations'] as const,
  lists: () => [...affiliationsQueryKeys.all, 'list'] as const,
  list: (params: ListAffiliationsParams) => [...affiliationsQueryKeys.lists(), params] as const,
};

interface UseListAffiliationsOptions {
  enabled?: boolean;
}

export function useListAffiliations(params: ListAffiliationsParams, options: UseListAffiliationsOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    placeholderData: (prev) => ({
      rows: prev?.rows ?? [],
      total: prev?.total ?? 0,
    }),
    queryKey: affiliationsQueryKeys.list(params),
    queryFn: async () => {
      return await listAffiliations(params);
    },
    enabled,
  });
}
